import { combineReducers } from 'redux'
import mainTab from './reducers/mainTab'
import datesModal from './reducers/datesModal'

export default combineReducers({
  mainTab,
  datesModal,
})
